import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {Icon, ThemeContext} from '../../';
import {wbr, getResizeImagePaths, onImageError} from '../../../../utils';

const MessageItem = (props) => {
  const {className, userImage, userName, message, self, sendAt, type} = props;
  const classes = classNames({
    chat__line: true,
    [`chat__line__type_${type}`]: true,
    [className]: Boolean(className),
    chat__line_self: Boolean(self),
  });
  const isAudience = type === 'audience';
  const messageClasses = classNames({
    chat__message: true,
    chat__message_balloon_left: !self,
    chat__message_balloon_right: Boolean(self),
    chat__message_competitor: !self && !isAudience,
    chat__message_anonymous: isAudience,
  });
  const hasAvatar = Boolean(userName) && Boolean(userImage);
  const styles = {};
  const timeSent = moment(sendAt).format('HH:mm:ss');
  const messageText = wbr(message);
  const {defaultImageURL, resizedImageURL} = getResizeImagePaths(userImage, 180);

  return (
    <ThemeContext.Consumer>
      {(theme) => {
        const {primaryColor, secondaryColor} = theme;
        if (userName && !isAudience) {
          styles.backgroundColor = self ? primaryColor : secondaryColor;
          styles.color = self ? primaryColor : secondaryColor;
        }

        if (type === 'info') {
          return (
            <div className={classes}>
              <div className="chat__messages">
                <div className="chat__message-text">{message}</div>
              </div>
            </div>
          );
        }

        return (
          <div className={classes}>
            <div className="chat__avatar">
              {hasAvatar ?
                <img
                  src={resizedImageURL}
                  onError={onImageError(defaultImageURL)}
                  alt={userName}
                /> :
                <Icon glyph="user-circle"/>}
            </div>
            <div className="chat__messages">
              <div className={messageClasses} style={styles}>
                <div className="chat__message-name">{userName}</div>
                <div
                  className="chat__message-text"
                  dangerouslySetInnerHTML={{__html: messageText}} // eslint-disable-line
                />
                <div className="chat__message-time">{timeSent}</div>
              </div>
            </div>
          </div>
        );
      }}
    </ThemeContext.Consumer>
  );
};

MessageItem.propTypes = {
  className: PropTypes.string,
  userImage: PropTypes.string,
  userName: PropTypes.string,
  message: PropTypes.string.isRequired,
  self: PropTypes.bool,
  sendAt: PropTypes.string,
  type: PropTypes.string,
};

MessageItem.defaultProps = {
  className: '',
  self: false,
  userImage: null,
  userName: '',
  sendAt: '',
  type: 'player',
};

export default MessageItem;
